import React from 'react';

import IconInfoOrenge from '../assets/images/common/icon-info-orange.svg';

type ErrorMessageProps = {
    errorMessage: string;
};

// 画面エラーメッセージ表示
export const ErrorMessage: React.FC<ErrorMessageProps> = ({ errorMessage }) => (
    <div className='alert_box_message'>
        <span className='icon'>
            <img src={IconInfoOrenge} alt='' />
        </span>
        <span className='text_alert'>{errorMessage}</span>
    </div>
);
